import { render, staticRenderFns } from "./ImageRotator.vue?vue&type=template&id=3fd38cc2&"
import script from "./ImageRotator.vue?vue&type=script&lang=js&"
export * from "./ImageRotator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports